import {Bar} from 'vue-chartjs'
import _ from 'lodash';
export default {
  extends: Bar,
  props: ['data'],
  watch: {
    data: function (newValue) {
    }
  },
  created() {
  },
  mounted() {
    this.renderChart({
      labels: _.map(this.data.projects, 'name'),
      datasets: [
        {
          label: 'Billable Hours',
          backgroundColor: '#a5a4a4',
          data: _.map(this.data.projects, project => project.billableHours.toFixed(2)),
          borderWidth: 1
        },
        {
          label: 'Non Billable Hours',
          backgroundColor: '#e0dbdb',
          data: _.map(this.data.projects, project => project.nonBillableHours.toFixed(2)),
          borderWidth: 1
        }
      ]
    }, {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          categoryPercentage: 0.9,
          barPercentage: 0.9
        }]
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Analytics/UsersPerProject/BarExample.js